/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCartPlus: {
  name: 'cart-plus';
  data: string;
} = {
  name: 'cart-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 2a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V6h-1a1 1 0 1 1 0-2h1V3a1 1 0 0 1 1-1ZM2 4a1 1 0 0 0 0 2h1.236l2.598 9.526A2 2 0 0 0 7.764 17h7.577a2 2 0 0 0 1.838-1.212l2.143-5A2 2 0 0 0 17.484 8H6a1.01 1.01 0 0 0-.143.01l-.691-2.536A2 2 0 0 0 3.236 4H2Zm5.764 11L6.4 10h11.083l-2.142 5H7.764ZM18 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill="currentColor"/></svg>`,
};
